import productModel from './productModel';
import getProductPrice from '../helpers/getProductPrice';


const addToCart = function googleAnalyticsAddToCart(product, quantity, eventCallback) {
  return {
    event: 'add_to_cart',
    ecommerce: {
      currency: 'USD',
      value: getProductPrice(product),
      items: [
        { ...productModel(product, { quantity }) },
      ],
    },
    eventCallback,
  };
};

export default addToCart;
